<template>
  <b-row v-if="!loading">
    <div v-for="(type, k) in futureItems" :key="k" class="col-md-6">
      <h5 v-if="k === 'power'">Elektrina (EEX-PXE Slovakian Power Futures)</h5>
      <h5 v-else-if="k === 'gas'">Plyn (EEX THE EGSI Natural Gas Future)</h5>

      <div v-for="(period, pk) in type" :key="pk">
        <h6 v-if="pk === 'year'">Rok</h6>
        <h6 v-else-if="pk === 'quarter'">Štvrťrok</h6>
        <h6 v-else-if="pk === 'month'">Mesiac</h6>
        <div class="form-inline mb-3">
          <b-form-group
            v-for="item in period"
            :key="item.id"
            class="mr-3"
            :label-for="'item-' + item.id"
          >
            <b-form-checkbox
              :ref="'item' + item.id"
              v-model="form[item.id]"
              :unchecked-value="0"
              :value="1"
              :name="'item-' + item.id"
              size="sm"
            >
              {{ item.future }}
            </b-form-checkbox>
          </b-form-group>
        </div>
      </div>
    </div>
  </b-row>
</template>
<script>
import energyMarketService from '@/services/api/energyMarketService'

export default {
  props: {
    userId: Number,
  },
  data() {
    return {
      loading: false,
      futures: [],
      form: {},
      error: null,
    }
  },
  computed: {
    futureItems() {
      const output = {}
      this.futures.forEach((val) => {
        output[val.type] = output[val.type] || {}
        Object.assign(output[val.type], {
          [val.period]: this.futures.filter(
            (i) => i.type === val.type && i.period === val.period,
          ),
        })
      })
      return output
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      energyMarketService.getActiveFutures().then((res) => {
        this.futures = res.data
        energyMarketService.getNotificationOptions(this.userId).then((res) => {
          for (let i of res.data.futuresIds) {
            this.form[i] = 1
          }
          this.loading = false
        })
      })
    },
    save() {
      const data = Object.keys(this.form).filter((i) => this.form[i] === 1)
      energyMarketService
        .saveNotificationOptions(this.userId, { futuresIds: data })
        .then(() => {})
    },
  },
}
</script>
